module.exports = __webpack_public_path__ + "img/CRLV 2024.75fcb8e0.png";